import { useMemo } from "react";
import { Navigate, Outlet, useOutletContext } from "react-router-dom";

import { FeatureSwitch, FeatureSwitches } from "./FeatureSwitches";
import { path as HomePath } from "v2/pages/home/HomeRoute";
import { useUser } from "routes/dataroutes/UserData";


export function useFeatureSwitch(featureSwitch: FeatureSwitch | undefined) {
  const user = useUser();

  const featureEnabled = useMemo(() => {
    // if no feature switch specified, assume the feature is enabled
    return featureSwitch ? FeatureSwitches[featureSwitch].isEnabled(user) : true;
  }, [ user, featureSwitch ]);

  return featureEnabled;
}


export function FeatureSwitchLayout(
  {
    featureSwitch,
    fallbackNavigateTo = HomePath
  }: {
    featureSwitch: FeatureSwitch;
    fallbackNavigateTo?: string;
  }) {
  const outletContext = useOutletContext();

  const featureEnabled = useFeatureSwitch(featureSwitch);

  if (featureEnabled) {
    return <Outlet context={ outletContext } />;
  } else {
    return <Navigate to={fallbackNavigateTo} replace />;
  }

}
